import { useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay, EffectFade } from 'swiper';
import { TimelineMax, TweenMax } from 'gsap';
import { useAnimate } from '../utils';
import { starterKitBuyNow1 } from '../utils/constant';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFLight from '@/components/UI/svg/LandingPage/EFLight';
import EFWifiRouter from '@/components/UI/svg/LandingPage/EFWifiRouter';
import EFPhone from '@/components/UI/svg/LandingPage/EFPhone';
import EFLaptop from '@/components/UI/svg/LandingPage/EFLaptop';
import EFRefrigerator from '@/components/UI/svg/LandingPage/EFRefrigerator';
import EFElectricHeater from '@/components/UI/svg/LandingPage/EFElectricHeater';
import EFMicroware from '@/components/UI/svg/LandingPage/EFMicroware';
import EFElectricKettle from '@/components/UI/svg/LandingPage/EFElectricKettle';
import EFCoffeeMaker from '@/components/UI/svg/LandingPage/EFCoffeeMaker';
import EFAirConditioner from '@/components/UI/svg/LandingPage/EFAirConditioner';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/img/landingPage/pc/');

export default function F1(): JSX.Element {
    const { useLang, Link, gtm, useRouter } = useGlobal();
    const { t } = useLang('landingPage');
    const { locale } = useRouter();

    const itemList = [
        {
            name: t('secF_Light'),
            times: `4 ${t('secF_days')}`,
            icon: <EFLight />,
        },
        {
            name: t('secF_phone'),
            times: `143 ${t('secF_times')}`,
            icon: <EFPhone />,
        },
        {
            name: t('secF_Refrigerator'),
            times: `13 ${t('secF_hrs')}`,
            icon: <EFRefrigerator />,
        },
        {
            name: t('secF_Microwave'),
            times: `1.3 ${t('secF_hrs')}`,
            icon: <EFMicroware />,
        },
        {
            name: t('secF_CoffeeMaker'),
            times: `1.6 ${t('secF_hrs')}`,
            icon: <EFCoffeeMaker />,
        },
        {
            name: t('secF_WiFiRouter'),
            times: `4 ${t('secF_days')}`,
            icon: <EFWifiRouter />,
        },
        {
            name: t('secF_laptop'),
            times: `26 ${t('secF_times')}`,
            icon: <EFLaptop />,
        },
        {
            name: t('secF_ElectricHeater'),
            times: `0.7 ${t('secF_hrs')}`,
            icon: <EFElectricHeater />,
        },
        {
            name: t('secF_ElectricKettle'),
            times: `1.1 ${t('secF_hrs')}`,
            icon: <EFElectricKettle />,
        },
        {
            name: t('secF_AirConditioner'),
            times: `0.9 ${t('secF_hrs')}`,
            icon: <EFAirConditioner />,
        },
    ];

    useEffect(() => {
        const { createScene, destroy, layoutH } = useAnimate();

        createScene({
            triggerElement: '.landing_page_F1',
            triggerHook: 1,
            offset: layoutH + 250,
        })
            .setClassToggle('.landing_page_F1', 'show')
            .addTo(aniController);

        createScene({
            triggerElement: '.landing_page_F1',
            triggerHook: 1,
            offset: 200,
            duration: (layoutH * 2) / 3,
        })
            .setTween(
                new TimelineMax().add(
                    TweenMax.to('.landing_page_F1_wrapper', 1, {
                        opacity: 1,
                    }),
                ),
            )
            .addTo(aniController);

        return () => destroy();
    }, []);

    const handleBuyNow = () => {
        try {
            // GA埋点
            gtm.push({
                event: 'uaEvent',
                event_name: 'buy',
                product_name: t('secF_pro_name'),
                position: `Solution Page_${t('secF_title')}`,
            });
            // fb埋点
            window?.fbq && window?.fbq('track', 'Search');
        } catch (e) {
            console.log(e);
        }
    };

    return (
        <div className={`landing_page_F1 ${css.landing_page_F1}`}>
            <div className="landing_page_F1_wrapper">
                <div className="page_F_left">
                    <div className="page_F_leftBox">
                        <div className="leftContentBox_1">
                            <div className="leftInnerBox">
                                <div className="secF_powerList">{t('secF_powerList')}</div>
                                <div className="leftListBox">
                                    {itemList.map((item: any, index: number) => (
                                        <div key={index} className="leftListItem">
                                            <div className="itemImg">{item.icon}</div>
                                            <div>
                                                <div className="itemName">{item.name}</div>
                                                <div className="itemTimes">{item.times}</div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className="leftContentBox_2">
                            <div>
                                <div className="secF_title">{t('secF_title')}</div>
                                <div className="secF_pro_name">{t('secF1_pro_name')}</div>
                                <div className="secF_pro_paramBox">
                                    <div className="secF_pro_param">{t('secF1_pro_param_1')}</div>
                                    <div className="secF_pro_param">{t('secF1_pro_param_2')}</div>
                                    <div className="secF_pro_param">{t('secF1_pro_param_3')}</div>
                                    <div className="secF_pro_param">{t('secF1_pro_param_4')}</div>
                                    <div className="secF_pro_param">{t('secF1_pro_param_5')}</div>
                                </div>
                                <div className="secF_pro_desc">{t('secF1_pro_desc')}</div>
                                <Link href={starterKitBuyNow1.replace('//us.', `//${locale}.`)} target="blank">
                                    <div className="secFButton btnHover" onClick={handleBuyNow}>
                                        {t('secF_buyNow')}
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="page_F_right">
                    <Swiper
                        pagination={{ clickable: true }}
                        modules={[Pagination, Autoplay, EffectFade]}
                        effect="fade"
                        className="swiperBox"
                        autoplay={{
                            delay: 5000,
                        }}
                        loop
                    >
                        <SwiperSlide>
                            <EFPic className="pageFImg img1" name={['ef_3.webp', 'ef_3.jpg']} />
                        </SwiperSlide>
                        <SwiperSlide>
                            <EFPic className="pageFImg scale" name={['ef_2.webp', 'ef_2.png']} />
                        </SwiperSlide>
                    </Swiper>
                </div>
            </div>
        </div>
    );
}
